import RoleSvc from '@/services/RoleSvc';
import PermissionSvc from '@/services/PermissionSvc';
import requestBuilder from '@/util/master/request.builder';

// ponytail: permission list is a bounded, system-defined set (not user-generated), single
// page fetch is fine; bump this if it ever needs to grow past a few hundred entries
const RELATED_FETCH_PAGINATION = { current: 1, pageSize: 500 };

// named export for parity with userrole/user/relation-configs.js's multi-relation exports
// eslint-disable-next-line import/prefer-default-export
export const permissionRelation = {
  title: 'Permission',
  accessKey: 'master_role',
  entityIdKey: 'prmsId',
  entityNameKey: 'prmsName',
  extraField: {
    key: 'rperOperations',
    label: 'Operations',
    columnLabel: 'Operations',
    type: 'checkboxes',
    default: [],
    options: [
      { text: 'Create', value: 'create' },
      { text: 'Read', value: 'read' },
      { text: 'Update', value: 'update' },
      { text: 'Delete', value: 'delete' },
    ],
  },
  async fetchAssigned(parentId, pagination) {
    const res = await RoleSvc.getRolePermissions({
      params: { ...requestBuilder.buildFilters(pagination, { rperRoleId: parentId }) },
    });
    const items = (res.data.data || []).map((row) => ({
      ...row,
      rperOperations: JSON.parse(row.rperOperations),
    }));
    return { items, totalSize: res.data.pagination?.totalData || 0 };
  },
  async fetchRelatedAll() {
    const res = await PermissionSvc.getPermissions({
      ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}),
    });
    return res.data.data || [];
  },
  async searchRelated(term) {
    const res = await PermissionSvc.getPermissionByName({ findField: 'prmsName', findValue: term });
    return res.data.data || [];
  },
  createAssigned(parentId, entityId, extra) {
    return RoleSvc.addRolePermission({
      rperRoleId: parentId,
      rperPrmsId: entityId,
      rperOperations: JSON.stringify(extra.rperOperations),
    });
  },
  deleteAssigned(row) {
    return RoleSvc.deleteRolePermission(row.rperId);
  },
  updateAssigned(row, operations) {
    return RoleSvc.updateRolePermission(row.rperId, {
      rperRoleId: row.rperRoleId,
      rperPrmsId: row.rperPrmsId,
      rperOperations: JSON.stringify(operations),
    });
  },
  getAssignedEntityId(row) {
    return row.rperPrms.prmsId;
  },
  getAssignedEntityName(row) {
    return row.rperPrms.prmsName;
  },
};
